import React, { useContext, useState } from "react";
import clsx from "clsx";
import { AppContext } from "./../../contexts/AppContextProvider";

const VersionSwitcher = (props) => {
  const { dispatch } = useContext(AppContext);

  const [version, setVersion] = useState(
    localStorage.configVersion || "production"
  );

  const tenantID = parseInt(localStorage.defaultTenantID);
  const tenantSlug = parseInt(localStorage.defaultTenantSlug);

  const switchVersion = (value) => {
    localStorage.setItem("configVersion", value);
    setVersion(value);
    dispatch({
      type: "APP-SET-TENANT",
      tenantID: tenantID,
      tenantSlug: tenantSlug,
      version: value,
    });
  };

  const [items] = useState([
    { label: "production", value: "production" },
    { label: "development", value: "development" },
  ]);

  let style = clsx("version-switcher", {
    "version-switcher--prod": version === "production",
    "version-switcher--dev": version === "development",
  });

  return (
    <div className={style}>
      <select
        onChange={(e) => switchVersion(e.currentTarget.value)}
        value={version}
      >
        {items.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default VersionSwitcher;
